export const WHATSAPP_PHONE = '201015955664'; // Replace with your real WhatsApp number

export const openWhatsAppWithMessage = (message = '') => {
  const base = `https://wa.me/${WHATSAPP_PHONE}`;
  const url = message ? `${base}?text=${encodeURIComponent(message)}` : base;
  window.open(url, '_blank');
};

